export enum TrashType {
    Organic = "organic",
    Plastic = "plastic",
    Metal = "metal",
    Paper = "paper",
}
